/*
 *
 * NexiClubWaiverPopup
 *
 * @version 1.0.0
 * @author Marco Alessandroni
 * @since 09-Jul-2025
*/

import React from 'react'
import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import Toggle from 'Hoc/ToggleComponent'
import MerchantModal from '@nexidigital/merchantmodal'
import formattedMessage from './languageModule'
import './NexiClubWaiverPopup.scss'

const NexiClubWaiverPopup = (props) => {
  const navigate = useNavigate()
  return (
    <Toggle>
      <MerchantModal
        title={formattedMessage.waiverTitle}
        description={formattedMessage.waiverDescription}
        onClose={() => props.actions.doHidePopup()}
        primaryButtonLabel={formattedMessage.waiverPrimaryButton}
        secondaryButtonLabel={formattedMessage.waiverSecondaryButton}
      // CTA "No", al tap l'utente ritorna alla pagina informativa di provenienza (Nexi_Nexi Club_Pagina informativa e consenso C3)
        secondaryAction={() => props.actions.doHidePopup()}
      // CTA "Si, rinuncio", al tap l'utente ritorna in homepage, dove l'entry point sarà ancora visiible
        primaryAction={() => { navigate('/'); props.actions.doHidePopup(); props.actions.doSaveConsent(props.localConsent, null) }}
        bigPopup={false}
      />
    </Toggle>
  )
}

NexiClubWaiverPopup.propTypes = {
  // Add here some propTypes
  // and set a minimal description i.e.
  /** Description of prop "baz". */
  actions: PropTypes.object,
  localConsent: PropTypes.string
}

NexiClubWaiverPopup.defaultProps = {
  // Add here some default propTypes values
  actions: {},
  localConsent: ''
}

export default NexiClubWaiverPopup
